<template>
  <div>
    <form action="" class="md-layout" @submit.prevent="handleSubmit">
      <div class="md-layout-item">
        <md-card-header>
          <div class="md-title">Editar Equipamento</div>
        </md-card-header>
        <md-card-content v-if="!sending">
          <div class="md-layout-item md-small-size-100">
            <md-field>
              <label :for="`nome${_uid}`"> Usuário </label>
              <md-input
                v-model.trim="equipamentoUsuario"
                name="nome"
                :for="`nome${_uid}`"
                :disabled="true"
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationClass('nome')">
              <label :for="`nome${_uid}`"> Nome (só afetará a exibição) </label>
              <md-input
                v-model.trim="form.nome"
                name="nome"
                :for="`nome${_uid}`"
                :disabled="sending"
              />
              <span v-if="!$v.form.nome.required" class="md-error"
                >Usuário é obrigatório</span
              >
              <span v-else-if="!$v.form.nome.minLength" class="md-error"
                >Minimo de 4 letras</span
              >
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationClass('descricao')">
              <label :for="`${_uid}descricao`">Descrição</label>
              <md-input
                :id="`${_uid}descricao`"
                v-model.trim="form.descricao"
                name="descricao"
                :disabled="sending"
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationClass('numeroTelefone')">
              <label :for="`${_uid}numeroTelefone`">Numero de telefone</label>
              <md-input
                :id="`${_uid}numeroTelefone`"
                v-model="form.numeroTelefone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                name="descricao"
                :disabled="sending"
              />
              <span v-if="!$v.form.numeroTelefone.required" class="md-error"
                >Telefone é obrigatório</span
              >
              <span v-if="!$v.form.numeroTelefone.minLength" class="md-error"
                >Telefone inválido</span
              >
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationClass('latitude')">
              <label for="latitude">Latitude (graus decimais)</label>
              <md-input
                id="latitude"
                v-model.number="form.latitude"
                v-coordinate-decimals
                name="latitude"
                type="number"
                step="0.000001"
                :disabled="sending"
              />
              <span v-if="!$v.form.latitude.required" class="md-error">
                Latitude é obrigatória
              </span>
              <span
                v-if="!$v.form.latitude.latitudeValidation"
                class="md-error"
              >
                Latitude inválida
              </span>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationClass('longitude')">
              <label for="longitude">Longitude (graus decimais)</label>
              <md-input
                id="longitude"
                v-model.number="form.longitude"
                v-coordinate-decimals
                name="longitude"
                type="number"
                step="0.000001"
                :disabled="sending"
              />
              <span v-if="!$v.form.longitude.required" class="md-error">
                Longitude é obrigatória
              </span>
              <span
                v-if="!$v.form.longitude.longitudeValidation"
                class="md-error"
              >
                Longitude inválida
              </span>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field>
              <label for="equipamentoConfigTipo"
                >Tipo de equipamento (afeta a configuração)</label
              >
              <md-select
                id="equipamentoConfigTipo"
                v-model="form.equipamentoConfigTipo"
                name="equipamentoConfigTipo"
              >
                <md-option :value="0"> Final Rede </md-option>
                <md-option :value="1"> Moto-bomba </md-option>
              </md-select>
            </md-field>
          </div>
        </md-card-content>

        <md-progress-bar v-if="sending" md-mode="indeterminate" />

        <md-card-actions>
          <md-button
            v-if="isAdmin()"
            class="md-raised md-accent"
            @click="() => (shouldShowDeleteDialog = true)"
          >
            Deletar
          </md-button>
          <md-button
            type="submit"
            class="md-raised md-primary"
            :disabled="sending"
          >
            Salvar
          </md-button>
        </md-card-actions>
      </div>
    </form>
    <md-dialog-confirm
      :md-active.sync="shouldShowDeleteDialog"
      md-title="Tem certeza?"
      md-content="Deletar um equipamento é uma ação irreversível. Após concluída os dados do equipamento não poderão ser recuperados"
      md-confirm-text="deletar"
      md-cancel-text="cancelar"
      @md-confirm="deleteEquipamento()"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'

import EquipamentoGerenciarAcoes from '@/components/equipamento/EquipamentoGerenciarAcoes.vue'
import auth from '@/utils/auth'
import http from '@/utils/http'

const latitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(90(\.0{0,6})?|[1-8]?\d(\.\d{0,6})?)$/.test(value.toString())
}

const longitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(180(\.0{0,6})?|([1-9]|1[0-7])?\d(\.\d{0,6})?)$/.test(
    value.toString()
  )
}

export default {
  name: 'EquipamentoEditForm',
  components: { EquipamentoGerenciarAcoes },
  mixins: [validationMixin],
  props: {
    equipamento: {
      type: Object,
      required: true,
    },
    equipamentoUsuario: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sending: false,
      form: {
        equipamentoConfigTipo: 0,
        nome: null,
        descricao: null,
        latitude: null,
        longitude: null,
        localId: null,
        senha: null,
        confirmarSenha: null,
        numeroTelefone: null,
      },
      shouldShowDeleteDialog: false,
    }
  },
  validations: {
    form: {
      nome: {
        required,
        minLength: minLength(4),
      },
      latitude: {
        required,
        latitudeValidation,
      },
      longitude: {
        required,
        longitudeValidation,
      },
      numeroTelefone: {
        required,
        minLength: minLength(14),
      },
    },
  },
  beforeMount() {
    this.loadFormFromProp()
  },
  methods: {
    isAdmin() {
      return auth.isAdmin()
    },
    async deleteEquipamento() {
      const response = await http.delete('equipamento', this.equipamento.id)
      if (response == null) return
      this.$router.push({ name: 'DashboardIndex' })
    },
    loadFormFromProp() {
      this.form = {
        ...this.equipamento,
      }
    },
    async handleSubmit() {
      this.$v.form.$touch()

      if (this.$v.form.$invalid) {
        return
      }

      this.sending = true

      await http.put('equipamento', {
        ...this.form,
        equipamentoId: this.form.id,
        botoes: this.form.botoesAcaoEquipamento,
      })

      this.sending = false

      this.$emit('change')
    },
  },
}
</script>

<style scoped lang="scss"></style>
